__turbopack_context__.v({
  "bounce": "SearchComponent-module__N294tG__bounce",
  "chipsContainer": "SearchComponent-module__N294tG__chipsContainer",
  "elementDivider": "SearchComponent-module__N294tG__elementDivider",
  "fadeIn": "SearchComponent-module__N294tG__fadeIn",
  "mask": "SearchComponent-module__N294tG__mask",
  "root": "SearchComponent-module__N294tG__root",
  "search": "SearchComponent-module__N294tG__search",
  "searchBtn": "SearchComponent-module__N294tG__searchBtn",
  "searchFood": "SearchComponent-module__N294tG__searchFood",
  "searchFoodOverlay": "SearchComponent-module__N294tG__searchFoodOverlay",
  "suggestions": "SearchComponent-module__N294tG__suggestions",
});
